import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Editor } from 'ngx-editor';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { NotificationTypeEnum } from 'src/app/shared/enums/notification-type.enum';
import { NotificationEmail } from 'src/app/shared/models/notificationEmail';

@Component({
	selector: 'app-notificationEmail-modal-ajout',
	templateUrl: './notificationEmail-modal-ajout.component.html',
	styleUrls: ['./notificationEmail-modal-ajout.component.scss']
})
export class NotificationEmailModalAjoutComponent {
	NAME_PATTERN = '^[^0-9]+$';

	editor: Editor;
	formEdit = new FormGroup({
		title: new FormControl('', [
			Validators.required,
			Validators.pattern(this.NAME_PATTERN),
		]),
		type: new FormControl(''),
		message: new FormControl('', [
			Validators.required,
		]),
		actif: new FormControl()
	});

	ngOnInit(): void {
		this.editor = new Editor();
	  }

	notificationTypes = NotificationTypeEnum;
	keys = Object.keys;
	
	//notificationTypes= NotificationTypeEnum;
	//keys: any[];

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked = false;

	constructor(
		public bsModalRef: BsModalRef,
		private facade: FacadeService,
		private logger: LogService,
	) {}

	onSubmit() {
		this.isValidateButtonClicked = true;
		const notificationEmail = new NotificationEmail();
		notificationEmail.title = this.formEdit.get('title').value;
		notificationEmail.type = this.formEdit.get('type').value;
		notificationEmail.message = this.formEdit.get('message').value;
		notificationEmail.actif = this.formEdit.get('actif').value;
		this.facade.notificationEmailService.addNotificationEmail(notificationEmail).subscribe({
			next: (succ) => {
				this.bsModalRef.hide();
				// this.isValidateButtonClicked=false;
			},
			error: (err) => {
				this.isValidateButtonClicked = false;
				this.facade.toastService.createHttpErrorToast(
					err.error.message ? err.error.message : '',
					err.status
				);
				this.logger.error(err);
			}
		});
	}

	get title() {
		return this.formEdit.get('title');
	}

	get type() {
		return this.formEdit.get('type');
	}

	get message() {
		return this.formEdit.get('message');
	}
	get actif() {
		return this.formEdit.get('actif');
	}
}
